<template>
    <div class="step3">
        <contact-person-form-wrapper />
        <invoice-form />
        <bank-number-from-wrapper />
        <invoice-additional-info />
    </div>
</template>

<script>
import ContactPersonFormWrapper from '../../components/ContactPersonForm/ContactPersonFormWrapper.vue';
import BankNumberFromWrapper from '../../components/BankNumberForm/bankNumberFromWrapper.vue';
import InvoiceForm from '../../components/Invoice/InvoiceForm.vue';
import InvoiceAdditionalInfo from '../../components/AdditionalInfoForm/InvoiceAdditionalInfo.vue';

export default {
  name: 'step3',
  components: {
    InvoiceForm, BankNumberFromWrapper, ContactPersonFormWrapper, InvoiceAdditionalInfo,
  },
};
</script>

<style scoped>

</style>
